var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social_login_info_wrapper body_7 f_gray_4"},[_c('img',{attrs:{"src":("/static/icons/" + _vm.provider + "_badge.svg")}}),_vm._v("\n  "+_vm._s(this.provider === 'naver' ? '네이버': '카카오')+" 로그인\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df70cf8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ai/AiLoginSocial.vue
// module id = null
// module chunks = 